import { VApp } from 'vuetify/lib/components/VApp';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VApp,{staticClass:"not-found-wrap"},[_c('div',{staticClass:"not-found d-flex flex-column justify-center align-center gradient-text"},[_c('h1',[_vm._v("404")]),_c('h3',[_vm._v("THAT PAGE WAS NOT FOUND")])])])}
var staticRenderFns = []

export { render, staticRenderFns }